"use client"
import { FC, Suspense } from 'react';


import MobileBar from './MobileBar';
import Logo from '../Logo/Logo';
import { Navigation } from './Navigation';
// import SearchBtn from '../SearchBtn';
import AvatarDropdown from '../AvatarDropdown';
import LoadingIndicator from '../LoadingIndicator';


interface NavbarProps {
  className?: string;
}

const Navbar: FC<NavbarProps> = () => {


  return (
    <div className=" bg-background/50 sticky top-0 backdrop-blur border-b z-10">
      <div className='flex justify-between items-center container mx-auto poppins'>
        <div className='hidden lg:block'>
          <Logo/>
        </div>
        <div className='hidden lg:block'>
          <Navigation />
        </div>
   
   
     
        {/* mobile device */}

        <div className='  lg:hidden'>
          <MobileBar />

        </div>
        <div className=' lg:hidden'>
          <Logo/>
        </div>

        <div className='flex flex-row'>
          {/* <SearchBtn/> */}
          <Suspense fallback={<LoadingIndicator/>}>

            <AvatarDropdown/>
          </Suspense>
        </div>
     
       
        
      </div>
    </div>
  );
};

export default Navbar;